// extracted by mini-css-extract-plugin
export var container = "_fs-0";
export var outlet = "_fs-1";
export var outletEnter = "_fs-2";
export var outletEnterActive = "_fs-3";
export var outletExit = "_fs-4";
export var outletExitActive = "_fs-5";